<template>
<div class="px-1 pt-1">
  <div class="d-flex gap-2 pb-3 align-items-start">
    <button class="btn btn-outline-secondary" @click="refresh()" :disabled="isLoading">
      <div v-if="isLoading" class="spinner-border spinner-border-sm"></div>
      <font-awesome-icon v-else :icon="['fas', 'rotate']" />
      <span class="d-none d-sm-inline">{{ $t('action.refresh') }}</span>
    </button>
    <ScanInput :instruction="$t('page.order.form.orderCode')" :help-text="$t('page.order.form.orderCodeHelp')" @scanned="submitForm" class="flex-grow-1" />
  </div>

  <OrderList @selected="goToOrderReceive" :statuses="statuses" :hide-received-by-delivery-interface="true" />
</div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { toast, type ToastOptions } from 'vue3-toastify';
import { useI18n } from 'vue-i18n';
import { router } from "@/services";
import { useOrdersStore, useSessionStore } from '@/stores';
import OrderList from "@/components/orders/OrderList.vue";
import ScanInput from "@/components/form/ScanInput.vue";
import { ORDER_HEAD_STATUS } from '@/models/Enums';

const statuses = [ORDER_HEAD_STATUS.inProgress];

const i18n = useI18n();
const ordersStore = useOrdersStore();
const sessionStore = useSessionStore();
const { isLoading, order } = storeToRefs(ordersStore);
const { selectedSiteId } = storeToRefs(sessionStore);

const goToOrderReceive = async (orderId: number) => {
  await router.push({ name: 'receiving', params: { orderId: orderId } });
}

async function refresh() {
  await ordersStore.fetchAll(false, statuses);
}

const submitForm = async (barcode: string) => {
  const code = barcode.trim();
  if (code === '') {
    return;
  }
  let matchedOrder = ordersStore.getByCode(code, selectedSiteId.value);
  if (!matchedOrder) {
    await ordersStore.fetchByCode(code);
    matchedOrder = order.value ?? undefined;
  }
  if (!matchedOrder) {
    toast.error(i18n.t('page.order.orderNotFoundError', { orderCode: code }), { autoClose: false, theme: 'colored' } as ToastOptions);
    return;
  }
  if (matchedOrder.status !== ORDER_HEAD_STATUS.inProgress) {
    toast.error(i18n.t('page.order.notInProgressError', { orderCode: code }), { autoClose: false, theme: 'colored' } as ToastOptions);
    return;
  }
  await goToOrderReceive(matchedOrder.id);
};
</script>
